import React, { Component } from 'react'
import '../styles/CalendarView.css'
import burger from '../images/burger-2.png'

class PopupMenu extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			value: props.placeholder,
			list: (props.list === null)? []: props.list,
			items: [],
			onItemSelected: props.onItemSelected,
			cStyle: props.cStyle
		}
		this.content = React.createRef()
		this.button = React.createRef()
	}

	onItemSelected(id, val) {
		if(this.state.onItemSelected != null) {
			this.state.onItemSelected(id, val)
		}
		this.content.current.className = 'rm-menu-items'
	}

	componentDidUpdate(prevProps) {
		if(this.props.list != prevProps.list) {
			const items = []
			for(const v of this.props.list) {
				items.push(<a href="#" id={v.id} onClick={(e) => {
					this.onItemSelected(e.target.id, e.target.innerHTML)
				}}>{v.name}</a>)
			}
			this.setState({items: items})
		}
	}

	render() {
		if(this.props.disabled && this.content.current != null) {
			this.content.current.className = 'rm-menu-items'
		}
		return(<div className="responsive-menu" style={this.state.cStyle}
			onMouseLeave={() => { this.content.current.className = 'rm-menu-items' }}>
			<div><img src={burger} className="burger-icon" onClick={() => {
				this.content.current.className = 'rm-content'
			}} /></div>
			<div className="rm-menu-items" ref={this.content} onMouseLeave={() => {this.content.current.className='rm-menu-items'}}>{this.state.items}</div>
		</div>)
	}
}

export default PopupMenu
